import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonSizes } from '@app/app/shared/styleguide/components/buttons/default/button.component';
import { IconSvgObject } from '@hugeicons/angular';

@Component({
  selector: 'ptl-nav-item-base',
  templateUrl: './nav-item-base.component.html',
  styleUrls: ['./nav-item-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemBaseComponent {
  @Input() text?: string;
  @Input() count?: number;
  @Input() icon?: IconSvgObject;
  @Input() size: ButtonSizes = 'l';
  @Input() isActive = false;
}
